import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ProjectFilters = ({
  filters,
  onFilterChange,
  onClearFilters,
  projectCounts
}) => {
  const categoryOptions = [
    { value: 'all', label: 'All Categories' },
    { value: 'cars', label: `Cars (${projectCounts?.cars || 0})` },
    { value: 'homes', label: `Homes (${projectCounts?.homes || 0})` },
    { value: 'refinancing', label: `Refinancing (${projectCounts?.refinancing || 0})` },
    { value: 'furniture', label: `Furniture (${projectCounts?.furniture || 0})` },
    { value: 'electronics', label: `Electronics (${projectCounts?.electronics || 0})` }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: `Active (${projectCounts?.active || 0})` },
    { value: 'pending', label: `Pending (${projectCounts?.pending || 0})` },
    { value: 'completed', label: `Completed (${projectCounts?.completed || 0})` },
    { value: 'draft', label: `Draft (${projectCounts?.draft || 0})` }
  ];

  const sortOptions = [
    { value: 'newest', label: 'Newest First' },
    { value: 'oldest', label: 'Oldest First' },
    { value: 'deadline', label: 'Deadline Soon' },
    { value: 'name', label: 'Name A–Z' }
  ];

  const handleFilterChange = (key, value) => {
    onFilterChange({ ...filters, [key]: value });
  };

  const hasActiveFilters = () => {
    return filters?.category !== 'all' ||
      filters?.status !== 'all' ||
      filters?.search !== '' ||
      filters?.dateFrom !== '' ||
      filters?.dateTo !== '';
  };

  return (
    <div className="bg-card border border-border rounded-2xl p-5 mb-6">
      {/* Search + Sort */}
      <div className="flex flex-col lg:flex-row gap-3 mb-4">
        <div className="flex-1 relative">
          <Icon name="Search" size={16} color="#9CA3AF" className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
          <input
            type="search"
            placeholder="Search stacks by name or vendor..."
            value={filters?.search}
            onChange={(e) => handleFilterChange('search', e?.target?.value)}
            className="w-full pl-9 pr-4 py-2.5 rounded-xl border border-border bg-background text-sm text-foreground placeholder-text-secondary focus:outline-none focus:border-primary/40 focus:ring-1 focus:ring-primary/20 transition-all"
          />
        </div>
        <div className="w-full lg:w-44">
          <Select
            options={sortOptions}
            value={filters?.sort}
            onChange={(value) => handleFilterChange('sort', value)}
            placeholder="Sort by"
          />
        </div>
      </div>

      {/* Filter Row */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
        <Select
          label="Category"
          options={categoryOptions}
          value={filters?.category}
          onChange={(value) => handleFilterChange('category', value)}
        />
        <Select
          label="Status"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => handleFilterChange('status', value)}
        />
        <Input
          label="From Date"
          type="date"
          value={filters?.dateFrom}
          onChange={(e) => handleFilterChange('dateFrom', e?.target?.value)}
        />
        <Input
          label="To Date"
          type="date"
          value={filters?.dateTo}
          onChange={(e) => handleFilterChange('dateTo', e?.target?.value)}
        />
      </div>

      {/* Clear Filters */}
      {hasActiveFilters() && (
        <div className="flex justify-end mt-3 pt-3 border-t border-border">
          <button
            onClick={onClearFilters}
            className="flex items-center gap-1.5 text-xs font-medium text-text-secondary hover:text-foreground transition-colors"
          >
            <Icon name="X" size={12} />
            Clear Filters
          </button>
        </div>
      )}
    </div>
  );
};

export default ProjectFilters;